import { initializeApp } from 'firebase/app';
import { getDatabase, ref, get, DataSnapshot, DatabaseReference } from "firebase/database";
import { getAnalytics, isSupported as isAnalyticsSupported } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';
import { getFirestore, doc, getDoc, getDocs, collection, CollectionReference, DocumentData, Firestore } from 'firebase/firestore';

import { ICourseInfo } from '../interfaces/ICourseInfo';
import {
  getCourseInfoPath,
  getMenuCategoryPath,
  getMenuItemsPath,
  getOrderInfoPath
} from './firebasePaths';
import {IMenuCategory} from "../interfaces/IMenuCategory";
import {IMenuItem} from "../interfaces/IMenuItem";

// TODO: Replace with your app's Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyBOsspc1XT1Fv9icACnpoZBAjo4Nia3Lcw",
  authDomain: "orderinone-93639.firebaseapp.com",
  // The value of `databaseURL` depends on the location of the database
  databaseURL: "https://nineteenth-hole-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "orderinone-93639",
  storageBucket: "orderinone-93639.firebasestorage.app",
  messagingSenderId: "238668259902",
  appId: "1:238668259902:web:1b554e5f0cf6452726e76f",
  // For Firebase JavaScript SDK v7.20.0 and later, `measurementId` is an optional field
  measurementId: "G-X033KTE3DS",
};

const app = initializeApp(firebaseConfig);

// Get a reference to the database service
const database = getDatabase(app);
// Analytics is only available in supported browser environments. Jest/jsdom and
// some privacy-restricted browsers do not expose the required storage APIs.
isAnalyticsSupported().then((isSupported) => {
  if (isSupported) {
    getAnalytics(app);
  }
});
// Initialize Firebase Authentication for downstream Firebase integrations.
getAuth(app);
// Get reference to Firestore
export const firestore = getFirestore(app);

// -NSVt_sD1_QYsjGD6h0P]

export function getFirestoreRef(): Firestore
{
  return firestore;
}

export async function getCourseInfoFromFirestore(courseId: string)
{
  const courseCollectionName = 'courses';
  // courseId = '-NSVt_sD1_QYsjGD6h0P';
  const docRef = doc(firestore, courseCollectionName, courseId);
  const snap = await getDoc(docRef);
  const iInfo = snap.data() as ICourseInfo;
  return iInfo;
}

export function getFirestoreInstance()
{
  return firestore;
}

export async function getMenuCategoriesFromFirestore(courseId: string)
{
  const courseCollectionName = 'courses';
  const categoryCollectionName = 'categoryCollection';

  const ref = collection(firestore, courseCollectionName, courseId, categoryCollectionName);
  const querySnapshot = await getDocs(ref);

  const categoryList: IMenuCategory[] = [];

  querySnapshot.forEach((doc) => {
    const category = doc.data() as IMenuCategory;
    category.id = doc.id;
    categoryList.push(category);
  });

  return categoryList;
}

export async function getCourseMenuItemsFromFirestore(courseId: string)
{
  const courseCollectionName = 'courses';
  const categoryCollectionName = 'menuItemCollection';

  const ref = collection(firestore, courseCollectionName, courseId, categoryCollectionName);
  const querySnapshot = await getDocs(ref);

  const menuList: IMenuCategory[] = [];

  // noinspection ES6MissingAwait
  querySnapshot.forEach((doc) => {
    const menuItem = doc.data() as IMenuItem;
    menuItem.id = doc.id;
    menuList.push(menuItem);
  });

  return menuList;
}




export async function getCourseInfoFromFirebase(courseId: string): Promise<DataSnapshot> {
  const path = getCourseInfoPath(courseId);
  const courseRef = ref(database, path);
  return get(courseRef);
}

export async function getMenuCategoriesFromFirebase(courseId: string): Promise<DataSnapshot> {
  const path = getMenuCategoryPath(courseId);
  const categoryRef = ref(database, path);
  return get(categoryRef);
}

export async function getCourseMenuItemsFromFirebase(courseId: string): Promise<DataSnapshot> {
  const path = getMenuItemsPath(courseId);
  const itemRef = ref(database, path);
  return get(itemRef);
}

export function saveOrderInfoToFirebase(courseId: string): DatabaseReference {
  const path = getOrderInfoPath(courseId);
  return ref(database, path);
}

export function getSaveOrderInfoFirestoreRef(courseId: string): CollectionReference<DocumentData>
{
  const ordersCollectionName = 'orderCollection';
  const courseOrderCollectionName = 'orders';
  const docRef = collection(firestore, ordersCollectionName, courseId, courseOrderCollectionName);

  return docRef
}

export function getSaveOrderBasketItemsFirestoreRef(courseId: string, orderId: string): CollectionReference<DocumentData>
{
  const ordersCollectionName = 'orderCollection';
  const courseOrderCollectionName = 'orders';
  const basketItemCollectionName = 'basketItems'

  const docRef = collection(firestore, ordersCollectionName, courseId, courseOrderCollectionName, orderId, basketItemCollectionName);

  return docRef
}
